<template>
	<!-- Add Person Dialog -->
  <div>
    <v-btn
          v-if="userIsAdmin"
          color="primary"
          class="add-person-button"
          outlined
          light
          @click.native.stop="addPersonOpen = !addPersonOpen"
    >
      Add Person
    </v-btn>
    <v-dialog v-model="addPersonOpen" persistent>
      <v-form v-model="addPersonFormIsValid" ref="addPersonForm">
        <v-card>
          <v-card-title class="headline">Add New Person?</v-card-title>
          <v-flex px-3>
            <v-text-field
              label="E-mail"
              v-model="newEmail"
              @blur="emailIsUnique"
              :rules="validationRules.emailRequiredValidUnique"
              required
            ></v-text-field>
            <v-text-field
              label="First Name"
              v-model="newFirstName"
              :rules="validationRules.nameRequiredValid"
              :counter="15"
              required
            ></v-text-field>
            <v-text-field
              label="Last Name"
              v-model="newLastName"
              :rules="validationRules.nameRequiredValid"
              :counter="15"
              required
            ></v-text-field>
          </v-flex>
          <v-card-actions>
            <v-flex p-6>
              <v-btn
                @click="addPerson(newEmail,newFirstName,newLastName)"
                :disabled="!addPersonFormIsValid"
              >Add</v-btn>
              <v-btn @click="clearAddDialogFields(); addPersonOpen = false">Cancel</v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import { addNewPerson } from "@/vue-service-form-person";
import { emailIsUnique, validationRules } from "@/vue-service-validation";

export default {
  data() {
    return {
      newEmail: "email@jahnelgroup.com",
      newFirstName: null,
      newLastName: null,
      addPersonFormIsValid: false,
      validationRules: validationRules,
      addPersonOpen: false,
    };
  },
  computed: {
    userIsAdmin(){
      return this.$store.getters.administrator;
    }
  },
  methods: {
    emailIsUnique,
    addPerson(){
      // Get list of all techs
      let techs = this.$store.getters.technology;

      // Set up an empty skills object
      let skills = {};

      // Transfer every skill to the skilsl object
      for(let key in techs){
        let tech = techs[key];
        let timestamp = Date.now();

        // Create a new changelog with initialized ratings and interested status
        let changelog = {};
        changelog[timestamp.toString()] = {Rating: -1, Interested: false};

        // Assign all tech details and rating, interested and changelog to the skill
        skills[key] = Object.assign({Rating: -1, Interested: false, Changelog: changelog}, tech);
      }

      addNewPerson(this.newEmail, this.newFirstName, this.newLastName, skills);
      this.addPersonOpen = false;
      this.clearAddDialogFields();
    },
    clearAddDialogFields(){
      this.$refs.addPersonForm.reset();
      this.newEmail = "email@jahnelgroup.com";
      this.newFirstName = null;
      this.newLastName = null;
    }
  },
};
</script>

<style>
.add-person-button{
  margin-left: 10px;
}
.icon-space {
  margin-right: 10px;
  margin-bottom: 0px;
  padding-right: 10px;
  padding-bottom: 0px;
}
.edit-font {
  font-size: 20px;
}
.secondary.v-card.v-sheet.theme--light {
    flex: 1 1 auto!important;
}
</style>



// WEBPACK FOOTER //
// src/components/People/AddPerson.vue